import FamilyDetails from "./familyDetails";
export default FamilyDetails;